<template>
  <div class="container mt-5">
    <div class="section-title">
      <h2>Ayurvedam</h2>
      <p>
        Department of Ayurveda offers comprehensive Ayurvedic treatment for
        Chronic Arthritis and other chronic diseases.
      </p>
    </div>
  </div>
  <DoctorsList :name="name" :queryName="queryName" :teamName="teamName" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DoctorsList from "@/components/Departments/common/DoctorsListTemplate3.vue";
import { DepartmentPropDataInterface } from "@/ts/interfaces";

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: "Ayurvedam Doctors",
      queryName: "Ayurvedam",
      teamName: "Ayurvedam team",
    };
  },
  components: { DoctorsList },
});
</script>
